import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './images/solum-logo.png'; // Update this path if needed
import './styles/Sidebar.css';

const Sidebar = ({ userRole, onLogoClick }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleMenu = () => setIsOpen(prev => !prev);

  useEffect(() => {
    /* close if clicked outside */
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const MenuList = () => (
    <ul>
      {userRole === 'admin' && (
        <>
          <li onClick={() => handleNavigate('/solum-tool-suite')}>Solum Tool Suite</li>
          <li onClick={() => handleNavigate('/solum-saas-suite')}>Solum SaaS Suite</li>
        </>
      )}
      <li onClick={() => handleNavigate('/videos')}>Videos</li>
      <li onClick={() => handleNavigate('/video-sync')}>Video Sync System</li>
    </ul>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="sidebar">
        <div className="logo" onClick={onLogoClick} style={{ cursor: onLogoClick ? 'pointer' : 'default' }}>
          <img className="solumLogo" src={logo} alt="Solum Logo" />
        </div>
        <MenuList />
      </div>

      {/* Mobile Dropdown Menu */}
      <div className="SidebarDropdownMenu" ref={dropdownRef}>
        <button className="SidebarDropdownButton" onClick={toggleMenu}>
          ☰ Menu
        </button>

        {isOpen && (
          <div className="SidebarDropdownContent">
            <MenuList />
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
